import { render } from "./BaseCard.vue?vue&type=template&id=714fc13e&scoped=true"
import script from "./BaseCard.vue?vue&type=script&lang=js"
export * from "./BaseCard.vue?vue&type=script&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=714fc13e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-714fc13e"

export default script